import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
  Loader,
} from "@coval/ui"

import { useDirectTemplateLaunch } from "./useDirectTemplateLaunch"

interface DirectTemplateRunDialogProps {
  onOpenChange: (open: boolean) => void
  organizationId: string
  orgSlug: string
  templateName: string
}

export function DirectTemplateRunDialog({
  onOpenChange,
  organizationId,
  orgSlug,
  templateName,
}: DirectTemplateRunDialogProps) {
  const directLaunch = useDirectTemplateLaunch({ organizationId, orgSlug })

  return (
    <AlertDialog
      open
      onOpenChange={(open) => {
        if (!directLaunch.isLaunching) {
          onOpenChange(open)
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Run saved template?</AlertDialogTitle>
          <AlertDialogDescription>
            {directLaunch.isPreparing
              ? "Loading the saved template details…"
              : directLaunch.validationError
                ? `This saved template can’t run: ${directLaunch.validationError}`
                : `This will start ${directLaunch.runCount} ${directLaunch.runCount === 1 ? "run" : "runs"} from the saved version of ${templateName}.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button variant="secondary" disabled={directLaunch.isLaunching}>
              Cancel
            </Button>
          </AlertDialogCancel>
          <Button
            onClick={() => {
              void directLaunch.launch()
            }}
            disabled={directLaunch.isDisabled || directLaunch.isLaunching}
            data-testid="template-run-confirm-button"
          >
            {directLaunch.isLaunching ? (
              <span className="inline-flex items-center gap-2">
                <Loader size="sm" />
                Launching…
              </span>
            ) : (
              "Run"
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
